(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_services"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Load Remixicon safely
  if (!document.querySelector('link[href*="remixicon.css"]')) {
    const remix = document.createElement("link");
    remix.rel = "stylesheet";
    remix.href = "https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css";
    document.head.appendChild(remix);
  }

  // Load Feather Icons safely
  if (typeof feather === "undefined") {
    const featherScript = document.createElement("script");
    featherScript.src = "https://cdn.jsdelivr.net/npm/feather-icons/dist/feather.min.js";
    featherScript.onload = function() {
      feather.replace();
    };
    document.head.appendChild(featherScript);
  } else {
    feather.replace();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
